import { Ability } from 'providers/casl'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { DOMAIN_FRAGMENT } from '../fragments/domain'
import { DomainData, DomainVars } from '../types/domain'

type Props = {
  ability: Ability
}

export const GET_DOMAIN = ({ ability }: Props): TypedDocumentNode<DomainData, DomainVars> => gql`
  ${DOMAIN_FRAGMENT({ ability })}

  query domain($id: ID!) {
    node(id: $id) {
      ... on Domain {
        ...DomainFragment
      }
    }
  }
`
